import editorTranslations from './editor/it';
import settingsTranslations from './settings/it';

export default {
    pages: {
        feedback: 'Feedback',
        disclaimer: 'Disclaimer',
        glossary: 'Aiuto',
    },
    home: {
        infoBanner:
            'Nei prossimi giorni cambieremo il processo di registrazione di werk-material.online. Vogliate prestare attenzione alla nostra e-mail che avete recentemente ricevuto.',
        title: 'Finalmente online: costi affidabili per tutti i tipi di costruzione!',
        lead: 'State cercando dei valori di riferimento precisi e dati di riferimento determinanti per qualsiasi tipo di edificio? Affidatevi alla nuova banca dati virtuale di werk-material.online. Qui potete trovare una grande quantità di dati e pratici metodi statistici relativi al settore svizzero della costruzione, in modo semplice, trasparente e completo.',
        segments: {
            data: {
                title: 'Dati di qualità come solida base di partenza',
                lead: 'Il CRB si occupa degli standard per il settore svizzero della costruzione e immobiliare in termini di metodi e valori di riferimento. Classificati in base al tipo di oggetto e ai codici dei costi di costruzione (CCC, e-CCC-E, eCCC-GC), consentono di calcolare i costi in modo affidabile, di eseguire descrizioni esatte delle costruzioni e processi razionali in un unico sistema. Altrettanto utile è quanto viene regolarmente pubblicato da werk, bauen + wohnen. Esso combina i dati utili per tutti i tipi di costruzione per un confronto a lungo termine, senza pari in questo settore. Tutti gli oggetti descritti sono stati selezionati in base a rigorosi criteri di qualità da parte della redazione. Anche per questo motivo werk, bauen + wohnen è considerato un punto di riferimento per la cultura della costruzione in Svizzera.',
            },
            analysis: {
                title: 'Strumenti di analisi intelligenti e una straordinaria quantità di dati',
                lead: "Sia per analizzare un singolo oggetto, sia per avere un'informazione generale, la combinazione vista da prospettive diverse sul mondo dei numeri tratta tutti i tipi di costruzione. Dal 1982, ogni anno werk-material.online ha avuto a disposizione 20 ulteriori oggetti. Grazie ai dati da essi derivanti, ha potuto offrire una varietà di informazioni uniche nel suo genere. Assieme ai valori dell'Ufficio federale di statistica, werk, bauen + wohnen ha potuto potenziare la sua banca dati, completata anche dai dati del CRB.",
            },
            architecture: {
                title: "La storia dell'architettura svizzera come complemento",
                lead: "Inoltre, werk-material.online propone uno sguardo particolare sull'architettura della Svizzera, combinando dati statistici con opere ampiamente documentate. Il confronto diretto degli oggetti mostra, sulla base dei dati, cosa occorre per allestire degli standard rigorosi per il settore della costruzione.",
            },
        },
        'want-access': "Volete ottenere l'accesso a werk-material.online?",
        'register-here': 'Registrati qui!',
        'register-buy': 'Registrarsi & acquistare',
    },
    register: {
        title: 'Benvenuto',
        'now-order-chargeable': 'Ordinare ora a pagamento',
        'invoice-order': 'Pagamento tramite fattura',
        'checking-and-delivery':
            'Dopo aver ricevuto il vostro ordine, verifichiamo i vostri dati e vi inviamo entro una settimana la fattura per posta. Il vostro abbonamento si rinnoverà automaticamente dopo un anno.',
        register: 'Registrarsi',
        'login-info':
            'Per acquistare i prodotti selezionati occorre avere un conto. P.f. registratevi e ritornate a questa pagina dopo la registrazione.<br/>Se avete già un conto, vogliate registrarvi. Verrete in seguito ricondotti a questa pagina.',
        order: {
            title: 'Seleziona Prodotto/i',
            discount: {
                title: 'Ribasso',
                'new-customer': 'Nuovo cliente',
                'member-crb': 'Socio CRB',
                'member-sia': 'Socio SIA',
                'subscriber-work-bauen-und-wohnen': 'Abbonato/a werk, bauen + wohnen',
                'discount-code': 'Codice ribasso',
            },
            'order-summary': "Panoramica dell'ordinazione",
            'annual-fee': 'Tassa annuale di utilizzo',
            'applied-discount': '15% Ribasso',
            'net-total': 'Totale netto',
            vat: 'IVA {{percentage}}%',
            total: 'Totale',
            promotion: 'Approfittate subito della promozione',
        },
        'data-collection': {
            dialog: {
                title: 'AVVISO IMPORTANTE PER LA RACCOLTA DATI:',
                description: {
                    title: '4.2 Disposizioni supplementari per l’utilizzo delle applicazioni web CRB in relazione ai dati dell’utente',
                    content:
                        "Il CRB fornisce agli utenti registrati con singole applicazioni web, la possibilità di presentare sé stessi e/o i loro progetti e/o i dati del progetto al CRB e/o ad altri utenti registrati delle applicazioni web CRB, mediante maschere predefinite nelle applicazioni web CRB. Le diverse applicazioni web CRB costituiscono una piattaforma di contatto e di informazione che permette agli utenti registrati la diffusione di informazioni su progetti propri e la ricezione di informazioni su progetti di altri utenti e di prendere contatto e scambiarsi informazioni con gli altri utenti. Di regola, l'utilizzo delle applicazioni web CRB presuppone una registrazione. Con la registrazione, l'utente può fornire informazioni su di sé o sulla propria azienda e/o sui propri progetti, in alcuni casi anche sui partecipanti al progetto. Le informazioni fornite devono essere veritiere e corrispondere alla realtà. La pubblicazione delle informazioni deve avvenire con il consenso delle persone interessate e il rispetto delle disposizioni in materia di protezione dei dati deve essere garantito. Il CRB non si assume alcuna responsabilità in merito e, in caso di rivendicazioni nei confronti del CRB, sarà ritenuto pienamente indenne e manlevato dall'utente responsabile. Il CRB si riserva tuttavia il diritto di rimuovere informazioni dell'utente inesatte, inadeguate, erronee e non rispondenti al vero, senza dover fornire giustificazioni e senza darne notizia all'utente. Il nome utente e la password scelti per l'accesso alle applicazioni web CRB devono restare segreti e soprattutto, non devono essere resi accessibili a terzi non registrati. I dati forniti dall'utente sulle applicazioni web CRB riguardo a se stesso, alla sua azienda, così come ai suoi progetti possono essere utilizzati illimitatamente dal CRB per la costituzione e per la messa a disposizione di altre funzioni e/o offerte. In particolare, nel caso di servizi e applicazioni web che possono essere utilizzate gratuitamente, le informazioni sui progetti degli utenti, quali dati, modelli, descrizioni, classificazioni, ecc., vengono riutilizzate in forma anonima e possono essere pubblicate dal CRB a proprio nome e/o utilizzate per la raccolta di valori e/o valutazioni statistiche che il CRB può pubblicare a proprio nome. Allo stesso modo, i partner di progetto indicati dall'utente possono essere invitati dal CRB a registrarsi a loro volta sulle applicazioni web CRB. L'utente può utilizzare le informazioni fornite da altri utenti su progetti e partner di progetto esclusivamente per scopi di informazione e di contatto. Ogni altro utilizzo di informazioni e dati disponibili sulle applicazioni web CRB è consentito solo previo consenso scritto del CRB.",
                },
                cancel: 'OK',
            },
        },
        userdata: {
            title: 'Dati Utente',
            email: 'Indirizzo e-mail',
            password: 'Password',
            'repeat-password': 'Ripeti Password',
            'immediate-access': 'Accesso immediato dopo la registrazione',
            'after-order':
                'Dopo aver ricevuto la vostra ordinazione, vi inviamo immediatamente per e-mail i dati di accesso a werk-material.online',
            'password-requirements': 'La password deve contenere almeno {{length}} caratteri',
        },
        billing: {
            title: 'Date per la fatturazione',
            salutation: 'Appellativo',
            company: 'Ditta',
            firstname: 'Nome',
            lastname: 'Cognome',
            phonenumber: 'Telefono',
            street: 'Via',
            postofficebox: 'Casella postale',
            postcode: 'NPA',
            city: 'Luogo',
            country: 'Paese',
        },
        'accept-terms': 'Accetto le Condizioni generali di vendita',
    },
    login: {
        title: 'Accedi al tuo account',
        'register-link': 'oppure registrati qui',
        'forgot-password': 'Password dimenticata?',
        'reset-password-instruction':
            "Inserisci l'indirizzo e-mail con cui ti sei registrato qui, e ti invieremo un link per reimpostare la tua password.",
    },
    'password-reset': {
        'forgot-password': 'Password dimenticata?',
    },
    'create-project': {
        project: 'Crea progetto',
        estimation: 'Calcolatore eCCC-E',
        name: 'Nome del progetto',
        'cost-index': {
            date: 'Livello di prezzo',
            'greater-region': 'Regione',
        },
        'submit-button': 'Creare',
        error: 'A causa della mancanza di dati sui prezzi, i progetti del Lichtenstein non sono supportati.',
    },
    editor: editorTranslations,
    settings: settingsTranslations,
    feedback: {
        title: 'Feedback',
        'submit-feedback': 'Inviare',
        'thank-you': 'Grazie per i vostri suggerimenti.',
        personal: {
            title: 'Informazioni personali',
            salutation: 'Appellativo',
            firstname: 'Nome',
            lastname: 'Cognome',
            email: 'E-Mail',
        },
        report: {
            title: 'Feedback',
            topic: 'Temi',
            text: 'Testo',
        },
    },
    customerService: {
        title: 'Servizio clientela',
        salutation: 'Appellativo',
        firstname: 'Nome',
        lastname: 'Cognome',
        email: 'E-Mail',
        text: 'Testo',
        'submit-customer-service-request': 'Inviare',
        'thank-you': 'Vi ringraziamo per il vostro messaggio, che elaboreremo il più presto possibile.',
    },
    company: {
        'cooperation-partners': 'Partners',
        'customer-service': 'Servizio Clienti',
    },
    account: {
        'change-password': {
            title: 'Modifica Password',
            instructions: 'Inserisci la tua vecchia password e scegline una nuova.',
            'current-password': 'Password corrente',
            'new-password': 'Nuova password',
            'repeat-new-password': 'Ripeti nuova password',
            change: 'Modifica',
        },
    },
    salutation: {
        male: 'Signore',
        female: 'Signora',
    },
    navigation: {
        account: 'Account',
        'change-password': 'Cambia password',
        order: 'Seleziona Prodotto/i',
    },
    common: {
        yes: 'Si',
        no: 'No',
        user: 'Utente',
        username: 'Nome Utente',
        'email-address': 'Indirizzo e-mail',
        password: 'Password',
        login: 'Accedi',
        logout: 'Esci',
        remember: 'Resta connesso',
        confirm: 'Conferma',
        submit: 'Invia',
        close: 'Chiudere',
        'processing-request': 'Elaborazione della richiesta. Questa operazione può richiedere diversi minuti',
        'do-not-reload': 'Si prega di non ricaricare la pagina e di avere pazienza. Grazie mille.',
        'waiting-for-sync': 'La vostra ordinazione è in fase di elaborazione. Vogliate pazientare.',
        'thank-you': 'Molte Grazie!',
        editor: 'Editor',
        ok: 'OK',
        cancel: 'Annullamento',
        continue: 'Continua',
        back: 'Indietro',
        add: 'Aggiungere',
        edit: 'Modifica',
        pagination: {
            page: 'Pagina',
            next: 'Prossimo',
            previous: 'Anteriore',
        },
    },
    errors: {
        'error-title': 'Si è verificato un errore',
        'no-required-roles':
            'Spiacente, si è verificato un errore. Si prega di uscire e rientrare. Se ciò non dovesse bastare, contattare il CRB all\'indirizzo <a href="mailto:support@crb.ch">support@crb.ch</a>.',
        'login-data-wrong': 'Nome utente e password non corrispondono.',
        'service-unavailable': 'Non è stato possibile raggiungere il server.',
        'incomplete-form': 'Il form inviato risulta essere incomplete, per favore, ricontrollare.',
        'server-failed': 'Il server non può rispondere alla richiesta al momento. Riprova più tardi.',
    },
    export: {
        language: 'Lingua',
        success: '{{count}} progetto è stato esportato con successo',
        success_plural: '{{count}} progetti sono stati esportati con successo',
        failed: '{{count}} progetto non può essere esportato',
        failed_plural: '{{count}} progetti non possono essere esportati',
    },
    import: {
        title: 'Importazione di progetti',
        text: 'I file Excel con il formato corretto possono essere importati qui',
        areaText: "Fare clic qui o trascinare i file in quest'area",
        success: 'Il progetto {{count}} è stato importato con successo',
        success_plural: '{{count}} progetti sono stati importati con successo',
        failed: 'Non è stato possibile importare il progetto {{count}}',
        failed_plural: 'I progetti di {{count}} non sono stati importati',
        error: {
            upload: {
                failed: 'Upload failed',
            },
            import: {
                invalido: {
                    file: 'Formato file non valido',
                    lang: 'Lingua non valida o mancante',
                    name: 'Nome mancante',
                    costIndexDate: 'Data indice dei costi non valida o mancante',
                    greaterRegion: 'Ragione maggiore non valida o mancante',
                    buildingClass: 'Tipo di struttura werk-material non valido o mancante',
                },
            },
        },
    },
    userinfo: {
        userEmail: 'Email',
        userId: 'ID utente',
        copy: {
            click: 'Clicca per copiare',
            clicked: 'Copiato!',
        },
    },
    project: {
        transfer: {
            'dialog-title': 'Trasferimento del progetto',
            'dialog-title_plural': 'Trasferimento dei progetti',
            content:
                "Inserite l'ID del destinatario e fate clic su Trasferisci.\n\nDopo il trasferimento, il progetto non sarà più visualizzato nell'elenco dei progetti!",
            content_plural:
                "Inserite l'ID del destinatario e fate clic su Trasferisci.\n\nDopo il trasferimento, i progetti non saranno più visualizzati nel loro elenco di progetti!",
            receiverId: 'ID ricevitore',
            cancel: 'Annullamento',
            confirm: 'Trasferimento',
        },
    },
    languages: {
        de: 'Tedesco',
        fr: 'Francese',
        it: 'Italiano',
        en: 'Inglese',
    },
};
